import _ from 'lodash';

angular.module('cian.geoService')
  .factory('GeoUtils', function () {
    function makeId() {
      var text = '',
        possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }

    var service = {};

    /**
     * @param {Array<string[]>} coordinates - координаты геометрии
     * {@link https://tech.yandex.ru/maps/doc/jsapi/2.0/ref/reference/geometry.Polygon-docpage }
     * Трехмерный массив, элементами которого являются двумерные массивы координат контуров многоугольника. Первый элемент описывает внешний контур, остальные - внутренние.
     * @param {string} name
     * @param {?{highlighted: boolean}} options
     * @return {{id: string, type: string, text: string, geoObject: object}}
     */
    service.createPolygonObject = function (coordinates, name, options) {
      options = _.defaults(options || {}, {
        highlighted: false
      });

      return {
        id: makeId(),
        type: 'polygon',
        text: name,
        geoObject: {
          source: {
            geometry: {
              type: 'Polygon',
              coordinates: coordinates
            },
            properties: {
              isHighlighted: options.highlighted
            }
          },
          options: {
            preset: 'search#polygon' + (options.highlighted ? '_highlighted' : '')
          }
        }
      };
    };

    service.createCircleObject = function (coordinates, radius, name, options) {
      options = _.defaults(options || {}, {
        highlighted: false
      });

      return {
        id: makeId(),
        type: 'circle',
        text: name,
        geoObject: {
          source: {
            geometry: {
              type: 'Circle',
              coordinates: coordinates,
              radius: radius
            },
            properties: {
              isHighlighted: options.highlighted
            }
          },
          options: {
            preset: 'search#circle' + (options.highlighted ? '_highlighted' : '')
          }
        }
      };
    };

    service.getCountry = function () {
      return 'Россия';
    };

    service.trimAddressNodeFromBeginning = function (str) {
      return str.substr(str.indexOf(', ') + 2, str.length - str.indexOf(',') - 2);
    };

    service.trimAddressNodeFromEnd = function (str) {
      return str.substr(0, str.lastIndexOf(', '));
    };

    /**
     * @memberOf GeoUtils
     * @param {string} str
     * @return {string}
     */
    service.removeCountryFromAddress = str =>
      str.replace(/(^Россия,)|(, Россия$)/i, '');

    service.polygonFromBounds = function (bounds) {
      return [[bounds[0][0], bounds[0][1]], [bounds[0][0], bounds[1][1]], [bounds[1][0], bounds[1][1]], [bounds[1][0], bounds[0][1]]];
    };

    // Проверка, что полигон как минимум треугольник
    // 4 точки, потому что последняя точка замыкает полигон и равна первой
    service.areCoordinatesCorrect = geoObject => {
      // Проверяем только полигоны
      if (_.get(geoObject, 'source.geometry.type') !== 'Polygon') return true;

      const coords = _.get(geoObject, 'source.geometry.coordinates[0]');
      return angular.isArray(coords) && coords.length >= 4;
    };

    return service;
  });



// WEBPACK FOOTER //
// ./src/components/geo-service/src/scripts/cian.geoUtils.js